import InnerHeader from "./InnerHeader";
import MainMenu from './MainMenu';
import Paper from '@mui/material/Paper';

function AboutMe(){
    return(
        <div>
           <InnerHeader />

            <Paper elevation={2} style={{padding:"10px", marginTop:"10px"}}>
                
                <h1 style={{textAlign:"center"}}>Hello, my name is Huo Chen</h1>
                
                <p>I am a high school math and computer science teacher with a passion for programming and data analysis. My journey into programming began in middle school during the era of Windows 95 and floppy disks. I started with BASIC and Visual Basic, creating my first game, a version of Snake Eat Apples, in Visual Basic.</p>
                <p>When I'm not teaching or traveling, I dedicate my time to studying programming (this webpage is produced using React.JS, my most recent study), developing software, and maintaining my personal website. I enjoy creating practical programs that address real-world problems and enhance my personal and professional experiences.</p>
                <p>My travel blog, Huo's Travel Blog (<a href="https://www.huostravelblog.com" target="_blank">https://www.huostravelblog.com</a>),documents the places I’ve visited and my travel experiences.</p>
                <p>In my coding lab, Huo's Coding Lab (<a href="https://codinglab.huostravelblog.com" target="_blank">https://codinglab.huostravelblog.com</a>), I practice coding and experiment with the latest programming frameworks and techniques. This platform offers a collection of free, intuitive, and user-friendly apps designed for educators, professors, adventurers, and anyone else in need. Most of these apps are solutions to problems I’ve encountered for which I couldn't find free online resources, so I decided to create them myself.</p>
            </Paper>
            <MainMenu shareLink="https://huoatwork.github.io" />
        </div>
    )
}

export default AboutMe